import React from "react";

/**
 * @component LetterArrowRightIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <LetterArrowRightIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const LetterArrowRightIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="LetterArrowRightIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 17h4v-3l5 4.5L6 23v-3H2v-3zM4 4a2 2 0 00-2 2v9h2V8l8 5 8-5v10h-7v2h7a2 2 0 002-2V6a2 2 0 00-2-2H4zm8 7L4 6h16l-8 5z"
      />
    </svg>
  )
);
LetterArrowRightIcon.displayName = "LetterArrowRightIcon";
export default LetterArrowRightIcon;
